(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ticho-buy-now-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('buy-now-summary')) {
    class BuyNowSummary extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.ticho-buy-now__trigger');
        this.dialog = this.querySelector('.ticho-buy-now');
        this.form = document.getElementById(this.dataset.formId);
        this.consent = this.querySelector('[data-buy-now-consent]');
        this.checkoutButton = this.querySelector('[data-buy-now-checkout]');
        this.itemsContainer = this.querySelector('.ticho-buy-now__items');
        this.error = this.querySelector('[data-buy-now-error]');
        this.subtotalElement = this.querySelector('[data-buy-now-subtotal]');
        this.shippingElement = this.querySelector('[data-buy-now-shipping]');
        this.totalElement = this.querySelector('[data-buy-now-total]');

        if (!this.trigger || !this.dialog || !this.form) return;

        this.trigger.addEventListener('click', () => this.open());
        this.querySelectorAll('.ticho-buy-now__close, [data-buy-now-close]').forEach((button) => {
          button.addEventListener('click', () => this.close());
        });
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
        this.dialog.addEventListener('close', () => document.body.classList.remove('ticho-buy-now-open'));
        this.consent.addEventListener('change', () => {
          this.checkoutButton.disabled = !this.consent.checked;
        });
        this.checkoutButton.addEventListener('click', () => this.checkout());
      }

      async open() {
        if (!this.form.reportValidity()) return;

        this.setError('');
        this.consent.checked = false;
        this.checkoutButton.disabled = true;
        this.dialog.showModal();
        document.body.classList.add('ticho-buy-now-open');
        await this.renderSummary();
      }

      close() {
        this.dialog.close();
      }

      getQuantity() {
        const externalInput = document.querySelector(`[name="quantity"][form="${this.dataset.formId}"]`);
        const quantityInput = externalInput || this.form.querySelector('[name="quantity"]');
        return Math.max(1, Number.parseInt(quantityInput?.value || '1', 10));
      }

      getShippingEstimate() {
        const container = this.closest('.product__info-container') || document.querySelector('.product__info-container');
        if (!container) return null;

        for (const element of container.querySelectorAll('p, div, span')) {
          const text = element.textContent.replace(/\s+/g, ' ').trim();
          const match = text.match(/Dostawa(?: jednej sztuki)? od:\s*([\d\s.,]+)\s*zł/i);
          if (!match || element.children.length > 3) continue;
          const value = Number.parseFloat(match[1].replace(/\s/g, '').replace(',', '.'));
          if (Number.isFinite(value)) return Math.round(value * 100);
        }

        return null;
      }

      formatMoney(cents) {
        const currency = window.Shopify?.currency?.active || 'PLN';
        const locale = document.documentElement.lang || 'pl-PL';
        return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
      }

      escapeHtml(value) {
        const element = document.createElement('div');
        element.textContent = value || '';
        return element.innerHTML;
      }

      normalizeImage(url) {
        if (!url) return '';
        return url.startsWith('//') ? `https:${url}` : url;
      }

      renderItem(item) {
        const image = this.normalizeImage(item.image);
        const variant = item.variantTitle
          ? `<p class="ticho-buy-now__item-variant">${this.escapeHtml(item.variantTitle)}</p>`
          : '';
        const imageMarkup = image
          ? `<img class="ticho-buy-now__item-image" src="${this.escapeHtml(image)}" alt="" width="82" height="82" loading="lazy">`
          : '<div class="ticho-buy-now__item-image"></div>';

        return `
          <article class="ticho-buy-now__item">
            ${imageMarkup}
            <div>
              <p class="ticho-buy-now__item-title">${this.escapeHtml(item.title)}</p>
              ${variant}
              <p class="ticho-buy-now__item-quantity">Ilość: ${item.quantity}</p>
            </div>
            <p class="ticho-buy-now__item-price">${this.formatMoney(item.linePrice)}</p>
          </article>
        `;
      }

      async renderSummary() {
        const quantity = this.getQuantity();
        const selectedItem = {
          title: this.dataset.productTitle,
          variantTitle: this.dataset.variantTitle,
          image: this.dataset.image,
          quantity,
          linePrice: Number(this.dataset.price) * quantity,
        };
        let existingItems = [];
        let cartSubtotal = 0;

        try {
          const response = await fetch(this.dataset.cartUrl, { headers: { Accept: 'application/json' } });
          if (response.ok) {
            const cart = await response.json();
            cartSubtotal = cart.total_price;
            existingItems = cart.items.map((item) => ({
              title: item.product_title,
              variantTitle: item.variant_title,
              image: item.image,
              quantity: item.quantity,
              linePrice: item.final_line_price,
            }));
          }
        } catch (error) {
          existingItems = [];
        }

        const subtotal = cartSubtotal + selectedItem.linePrice;
        const shipping = this.getShippingEstimate();
        const items = [...existingItems, selectedItem];

        this.itemsContainer.innerHTML = items.map((item) => this.renderItem(item)).join('');
        this.subtotalElement.textContent = this.formatMoney(subtotal);
        this.shippingElement.textContent = shipping === null ? 'ustalana w kasie' : this.formatMoney(shipping);
        this.totalElement.textContent = shipping === null
          ? this.formatMoney(subtotal)
          : this.formatMoney(subtotal + shipping);
      }

      async checkout() {
        if (!this.consent.checked) return;

        this.setError('');
        this.checkoutButton.disabled = true;
        this.checkoutButton.setAttribute('aria-busy', 'true');
        this.checkoutButton.querySelector('span').textContent = 'Przygotowujemy kasę…';

        try {
          const addResponse = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(this.form),
          });

          if (!addResponse.ok) {
            const result = await addResponse.json();
            throw new Error(result.description || 'Nie udało się dodać produktu do zamówienia.');
          }

          await fetch(this.dataset.cartUpdateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              attributes: {
                'Akceptacja regulaminu': `Tak — Kup teraz (${new Date().toISOString()})`,
              },
            }),
          });

          window.location.assign(this.dataset.checkoutUrl);
        } catch (error) {
          this.setError(error.message || 'Coś poszło nie tak. Spróbuj ponownie.');
          this.checkoutButton.disabled = false;
          this.checkoutButton.removeAttribute('aria-busy');
          this.checkoutButton.querySelector('span').textContent = 'Akceptuję i przechodzę do kasy';
        }
      }

      setError(message) {
        this.error.textContent = message;
        this.error.hidden = !message;
      }
    }

    customElements.define('buy-now-summary', BuyNowSummary);
  }
  } catch(e) { console.error(e); }
})();

})();
